<template>
  <div>
    <!-- 面包屑导航区 -->
    <!--<el-breadcrumb separator-class="el-icon-arrow-right">-->
    <!--<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>-->
    <!--<el-breadcrumb-item>交易记录</el-breadcrumb-item>-->
    <!--<el-breadcrumb-item>交易记录列表</el-breadcrumb-item>-->
    <!--</el-breadcrumb>-->
    <!-- 卡片视图 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-button type="primary" @click="goAddPage">签新合约</el-button>
        </el-col>
      </el-row>
      <!-- 表格数据 -->
      <el-table :data="goodsList" border stripe  v-loading="loading">
        <el-table-column type="index"></el-table-column>
        <el-table-column label="主账户名" prop="out_uid" min-width="150px"></el-table-column>
        <el-table-column label="名称" prop="name" min-width="150px"></el-table-column>
        <el-table-column label="描述" prop="desc" min-width="150px"></el-table-column>
        <el-table-column label="状态" prop="status_wenan" min-width="150px"></el-table-column>
        <el-table-column label="创建时间" prop="create_time" min-width="200px">
          <template slot-scope="scope">{{scope.row.create_time | dataFormat }}</template>
        </el-table-column>
        <el-table-column label="更新时间" prop="update_time" min-width="200px">
          <template slot-scope="scope">{{scope.row.update_time | dataFormat }}</template>
        </el-table-column>
        <el-table-column label="操作" min-width="350px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini"  @click="toDetail(scope.row.id)" v-if=" scope.row.status == 2">去操作</el-button>
            <el-button type="success" icon="el-icon-plus" size="mini"  @click="addAccount(scope.row.id)" v-if=" scope.row.status == 1">开通账户</el-button>
            <el-button type="primary" icon="el-icon-edit" size="mini"  @click="continueAccount(scope.row.id)" v-if=" scope.row.status == 0">继续签约</el-button>
            <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-minus"
                    @click="removeById(scope.row.id)"
            >解除合约</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="queryInfo.pagenum"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="queryInfo.pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
    export default {
        name: "List",
        data () {
            return {
                queryInfo: {
                    query: '',
                    pagenum: 1,
                    pagesize: 10
                },
                // 商品列表
                goodsList: [],
                // 商品总数
                total: 0,
                offset:0,
                oldoffset:0,
                loading: true
            }
        },
        created(){
            this.getList();
        },
        methods:{
            async getList(){
                let that=this;
                const { data: res } = await this.$http.post('',
                    {
                        "oper": "get_my_multi",
                        "ent": "account",
                        "info": {
                            "count":this.queryInfo.pagesize,
                            "offset":this.offset,
                        }
                    }
                )
                console.log(res)
                if(res.code==0){
                    this.goodsList = res.data.data_list;
                    that.total = res.data.total_count;
                    this.loading=false;
                    this.oldoffset=this.offset;
                    this.offset+=this.queryInfo.pagesize
                }else{
                    this.$message(res.msg);
                }

            },
            async addAccount(id){
                this.loading=true;
                const { data: res } = await this.$http.post('',
                    {
                        "oper": "open",
                        "ent": "account",
                        "info": {
                            "id":id
                        }
                    }
                )
                if(res.code==0){
                    this.$message('开通成功');
                    this.offset=this.oldoffset;
                    this.getList()
                } else{
                    this.$message({
                        message:res.msg,
                        duration:6000
                    });;
                    this.loading=false;

                }
            },
            async continueAccount(id){
                const { data: res } = await this.$http.post('',
                    {
                        "oper": "continue",
                        "ent": "account",
                        "info": {
                            "id":id
                        }
                    }
                )
                if(res.code==0){
                    window.open(res.data.url);
                } else{
                    this.$message({
                        message:res.msg,
                        duration:6000
                    });;
                }
            },
            toDetail(id){
                console.log(id)
                this.$router.push({ name: 'detail', params: { id: id }});
            },
            async goAddPage(){
                const { data: res } = await this.$http.post('',
                    {
                        "oper": "add",
                        "ent": "account",
                        "info": {
                        }
                    }
                )
                console.log(res)
                if(res.code==0){
                    window.open(res.data.url);
                } else{
                    this.$message({
                        message:res.msg,
                        duration:6000
                    });;
                }
            },

            removeById(id){
                this.$confirm('此操作将解约，是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async() => {
                    this.loading=true;
                    const { data: res } = await this.$http.post('',
                        {
                            "oper": "dismiss",
                            "ent": "account",
                            "info": {
                                "id":id
                            }
                        }
                    )
                    console.log(res)
                    if(res.code==0){
                        this.$message('删除成功');
                        this.offset=this.oldoffset;
                        this.getList();
                    } else{
                        this.$message({
                            message:res.msg,
                            duration:6000
                        });;
                        this.loading=false;
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },

            handleCurrentChange (newSize) {
                this.queryInfo.pagenum = newSize;
                this.offset=(newSize-1)*this.queryInfo.pagesize;
                this.oldoffset=this.offset;
                this.getList()
            },
            handleSizeChange (newSize) {
                this.queryInfo.pagesize = newSize
                this.offset=0
                this.oldoffset=this.offset;
                this.getList()
            },



        }
    }
</script>

<style scoped>

</style>
